"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const effects_1 = require("redux-saga/effects");
const actions_1 = require("~/store/actions");
const selectors_1 = require("~/store/selectors");
const consts_1 = require("./consts");
function* fetchBOM(_) {
    // Previously this saga pruned defaultFasteners to only keep entries whose
    // series+connectionType existed in the current BOM extrusions. However, the
    // pruning logic was fragile: it only inspected groups[0] (extrusions) and
    // used only the first connectionItem per BOM item. After assembly dedup
    // (which groups identical items and keeps only the representative's
    // connectionItems), many valid connection types were absent from the BOM
    // response, causing their defaults to be incorrectly pruned. This forced
    // users to re-select the fastener type on every add instead of once.
    //
    // Stale defaults (for series/types no longer in the project) are harmless:
    // they simply won't match any incoming connection and won't auto-apply.
    // So we no longer prune them.
    yield;
}
const getCurrentCategoryGroup = (state) => state.catalogState.categoryGroup;
function* handleNonCatalogCategoryGroup({ payload }) {
    if (!payload) {
        const currentCategoryGroup = yield (0, effects_1.select)(getCurrentCategoryGroup);
        if (currentCategoryGroup) {
            const categoriesWithItems = yield (0, effects_1.select)((state) => (0, selectors_1.selectCatalogGroupsWithItems)(state));
            if (!categoriesWithItems.map((category) => category.name).includes(currentCategoryGroup.name)) {
                yield (0, effects_1.put)((0, actions_1.setCatalogCategoryGroup)(null));
            }
        }
    }
}
function* rootSaga() {
    yield (0, effects_1.all)([(0, effects_1.takeLatest)(consts_1.REQUEST_BOM_SUCCESS, fetchBOM), (0, effects_1.takeLatest)(consts_1.EDIT_MODE, handleNonCatalogCategoryGroup)]);
}
exports.default = rootSaga;
